import React from 'react'
import styles from './FormVertical.module.scss'
import { IFormData } from './IFormData'

export function FormVerticalLayout<T extends IFormData<T>>(props: {
	children: React.ReactNode
}): React.ReactElement {
	return (
		<div className={styles.table}>
			<div className={styles.tbody}>{props.children}</div>
		</div>
	)
}
